(function($) {

    'use strict'

	var logoSlider = function() {
		$('.owl-carousel').owlCarousel({
			loop: true,
			nav: true,
			smartSpeed: 600,
			margin: 45,
			responsiveClass: true,
			items:5,
			navText: [
				"",
				""
			],
			responsive: {
				0:{
					items:3,
					center: true,
					margin: 25,
				},
				767:{
					items:3,
				},
				1000:{
					items:5
				}
			}
		})
	};

	var initLogoSlider = function() {
		logoSlider();
		$('.owl-carousel').find('.owl-nav').removeClass('disabled');
		$('.owl-carousel').on('changed.owl.carousel', function(event) {
			$(this).find('.owl-nav').removeClass('disabled');
		});
	}

	$(document).ready(function() {
		if($('div').hasClass('logo-slider')) {
			initLogoSlider()
		}
	})

})(jQuery)